import { render, staticRenderFns } from "./ShopXqSetting.vue?vue&type=template&id=6e0b4821&"
import script from "./ShopXqSetting.vue?vue&type=script&lang=js&"
export * from "./ShopXqSetting.vue?vue&type=script&lang=js&"
import style0 from "./ShopXqSetting.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports